import { authAtom } from "@portal/store/auth/auth";
import { sessionStore } from "@portal/util/browser-storage";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Flex } from "../../../../BaseComponents/Flex/Flex";
import { PageOutLet } from "../../Components/routerComponent";
import { usePageNavigate } from "../../hooks/usePageNavigae";

function PublicLayout() {
  const { authStatus } = useAtomValue(authAtom);
  const navigate = usePageNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authStatus === "authenticated") {
      const queryParams = new URLSearchParams(location.search);
      navigate({
        appPage: "INVOICES",
        pathParams: {
          customer_id: sessionStore.getItem("customer_id") as string,
        },
        searchParams: queryParams,
      });
    }
  }, [authStatus, location.search, navigate]);
  return (
    <Flex justify="center" align="center" style={{ height: "100%" }}>
      <PageOutLet />
    </Flex>
  );
}

export { PublicLayout };
